<template>
    <div>
      <!-- page-title -->
      <section class="page__title p_relative">
        <div class="bg-layer" style="background-image:url(assets/images/resource/page-title-bg.jpg)"></div>
        <div class="container">
          <div class="content__box p_relative">
            <ul class="bread__crumb">
              <li><router-link to="/">Home</router-link></li>
              <li><span>-</span> Services Details</li>
            </ul>
            <h1 class="title">Services Details</h1>
          </div>
        </div>
      </section>
      <!-- page-title end -->
  
      <!-- service-page end-->
      <div class="service__details p_relative">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="service__details__left">
                <div class="sidebar__widget">
                  <div class="all__service">
                    <h4>All Services</h4>
                  </div>
                  <ul class="service__details__1__cat">
                    <li><router-link to="/technology-details/digital-marketing">Digital Marketing <i class="icon-02"></i></router-link></li>
                    <li><router-link to="/technology-details/ui-ux-design">UX/ UI Design <i class="icon-02"></i></router-link></li>
                    <li class="active"><router-link to="/technology-details/seo-marketing">SEO Marketing <i class="icon-02"></i></router-link></li>
                    <li><router-link to="/technology-details/graphic-design">Graphic Design <i class="icon-02"></i></router-link></li>
                    <li><router-link to="/technology-details/development">Home Buying <i class="icon-02"></i></router-link></li>
                  </ul>
                </div>
                <div class="sidebar__widget_network" style="background-image: url(assets/images/resource/base.png);">
                  <h3>Contact Us For Any Requirement</h3>
                  <div class="services__icon">
                    <i class="icon-19"></i>
                  </div>
                  <p>Need help? Call us:</p>
                  <h4>(+800) 1234 5678 90</h4>
                </div>
              </div>
            </div>
  
            <div class="col-xl-8 col-lg-12 col-md-12">
              <div class="service__right">
                <figure>
                  <img src="assets/images/resource/service-details.jpg" alt="Service Image" />
                </figure>
                <h2>Enhancing Real-world Experiences with AR Technology.</h2>
                <p>
                  The applications of AR are vast and diverse. From entertainment and gaming, where users can see virtual characters in their surroundings, to education, where complex subjects can be visualized and explained in an immersive way. We understand that every business has unique needs. Our technology solutions are tailored to match your specific requirements, ensuring optimal performance and efficiency. Our dedicated team of technology professionals comprises experienced engineers, developers, and researchers who are passionate about pushing the boundaries of technology.
                </p>
  
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <li><a href="#"><i class="icon-04"></i> Human Resources</a></li>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <li><a href="#"><i class="icon-04"></i> Web Development</a></li>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <li><a href="#"><i class="icon-04"></i> Content Writing</a></li>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <li><a href="#"><i class="icon-04"></i> IT Support</a></li>
                  </div>
                </div>
  
                <p>
                  The applications of AR are vast and diverse. From entertainment and gaming, where users can see virtual characters in their surroundings, to education, where complex subjects can be visualized and explained in an immersive way. We understand that every business has unique needs. Our technology solutions are tailored to match your specific requirements, ensuring optimal performance and efficiency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- service-page end -->
  
      <!-- service-contact -->
      <div class="service__contact see__pad p_relative">
        <div class="container">
          <div class="service__contact__block">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <div class="service__form__data">
                  <div class="form__title">
                    <div class="title__data">
                      <div class="sub__title">
                        <h4>Contact Us</h4>
                      </div>
                      <div class="title">
                        <h2>Send Message</h2>
                      </div>
                    </div>
                  </div>
                  <div class="form-inner">
                    <form method="post" action="contact.php" class="default-form">
                      <div class="row clearfix">
                        <div class="col-xl-6 form-group">
                          <input type="name" name="name" placeholder="Your Name *" required="" />
                        </div>
                        <div class="col-xl-6 col-lg-12 form-group">
                          <input type="email" name="email" placeholder="Your Email *" required="" />
                        </div>
                        <div class="col-xl-6 col-lg-12 form-group">
                          <input type="text" name="subject" placeholder="Your Subject" required="" />
                        </div>
                        <div class="col-xl-6 col-lg-12 form-group">
                          <input type="text" name="phone" placeholder="Your Phone" required="" />
                        </div>
                        <div class="col-xl-6 col-lg-12 form-group">
                          <textarea name="message" placeholder="Message"></textarea>
                        </div>
                        <div class="col-xl-12 form-group message-btn btn-box">
                          <button class="theme-btn theme-btn-one" type="submit" name="submit-form">Send your Message</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="service__contact__img">
                  <figure>
                    <img src="assets/images/resource/man.png" alt="Man Image" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- service-contact-end -->
    </div>
  </template>
  
  <script>
  export default {
    name: "TechnologyDetails",
  };
  </script>
  
  <style scoped>
  .page__title {
    position: relative;
    background-size: cover;
    padding: 120px 0;
  }
  
  .bg-layer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center center;
    opacity: 0.5;
  }
  
  .auto-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }
  
  .content__box {
    position: relative;
    z-index: 1;
    padding: 50px 0;
  }
  
  .bread__crumb {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .bread__crumb li {
    display: inline;
    font-size: 14px;
  }
  
  .bread__crumb li a {
    color: #fff;
    text-decoration: none;
  }
  
  .bread__crumb li span {
    color: #fff;
  }
  
  .title {
    font-size: 30px;
    font-weight: 700;
    color: #fff;
    margin-top: 20px;
  }
  
  .service__details {
    position: relative;
    z-index: 1;
    padding-top: 50px;
    padding-bottom: 70px;
  }
  
  .service__details__left {
    padding-right: 30px;
  }
  
  .sidebar__widget {
    margin-bottom: 30px;
  }
  
  .sidebar__widget h4 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  
  .service__details__1__cat {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .service__details__1__cat li {
    margin-bottom: 10px;
  }
  
  .service__details__1__cat li a {
    font-size: 16px;
    color: #333;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  
  .service__details__1__cat li a i {
    margin-left: 5px;
  }
  
  .service__right h2 {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
  }
  
  .service__right p {
    font-size: 16px;
    color: #555;
    line-height: 1.8;
  }
  
  .service__contact {
    padding: 70px 0;
    background-color: #f7f7f7;
  }
  
  .service__contact__block {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .service__form__data {
    background-color: #fff;
    padding: 40px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }
  
  .form__title h4 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  
  .theme-btn {
    padding: 10px 20px;
    background-color: #007bff;
    color: #fff;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .theme-btn:hover {
    background-color: #0056b3;
  }
  </style>
  